import { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';

interface Props {
  className?: string;
}

const Spinner: FC<Props> = ({ className }) => {
  return <FontAwesomeIcon icon={faSpinner} spin className={className} />;
};

export default Spinner;
